export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الوصف"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التفاصيل المطلوبة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعطي"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تستلم"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحدود"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متاح"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المهلة"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["د"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نشط"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رابط الإعلان"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرّف الصانع"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الصانع"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تاريخ الإنشاء"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متاح فقط للمستخدمين الموثقين"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أيام"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ساعات"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["دقائق"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تاريخ البدء"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تاريخ الانتهاء"])}
}